function cov_t0p2xheyn() {
  var path = "/app/src/utils/get-lang-code.ts";
  var hash = "f14fb62eed68f2a2b9cd93f00092a02758bddc44";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/get-lang-code.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 27
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "1": {
        start: {
          line: 4,
          column: 19
        },
        end: {
          line: 4,
          column: 53
        }
      },
      "2": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 16,
          column: 3
        }
      },
      "3": {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 9,
          column: 21
        }
      },
      "4": {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 21
        }
      },
      "5": {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 55
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 27
          },
          end: {
            line: 3,
            column: 28
          }
        },
        loc: {
          start: {
            line: 3,
            column: 56
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 3
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 3,
            column: 28
          },
          end: {
            line: 3,
            column: 45
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 3,
            column: 41
          },
          end: {
            line: 3,
            column: 45
          }
        }],
        line: 3
      },
      "1": {
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 17
          }
        }, {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 9,
            column: 21
          }
        }, {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 10,
            column: 17
          }
        }, {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 12,
            column: 21
          }
        }, {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        }],
        line: 6
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0, 0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f14fb62eed68f2a2b9cd93f00092a02758bddc44"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_t0p2xheyn = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_t0p2xheyn();
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { Lang } from 'src/types/lang-locale-type';
cov_t0p2xheyn().s[0]++;
export var getLangCode = function getLangCode() {
  var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_t0p2xheyn().b[0][0]++, 'en');
  cov_t0p2xheyn().f[0]++;
  var _ref = (cov_t0p2xheyn().s[1]++, lang.replace(/-/g, '_').split('_')),
    _ref2 = _slicedToArray(_ref, 1),
    locale = _ref2[0];
  cov_t0p2xheyn().s[2]++;
  switch (locale.toLowerCase()) {
    case Lang.en:
      cov_t0p2xheyn().b[1][0]++;
    case 'eng':
      cov_t0p2xheyn().b[1][1]++;
      cov_t0p2xheyn().s[3]++;
      return Lang.en;
    case Lang.ar:
      cov_t0p2xheyn().b[1][2]++;
    case 'ara':
      cov_t0p2xheyn().b[1][3]++;
      cov_t0p2xheyn().s[4]++;
      return Lang.ar;
    default:
      cov_t0p2xheyn().b[1][4]++;
      {
        cov_t0p2xheyn().s[5]++;
        throw new Error("Unexpected lang code: ".concat(lang));
      }
  }
};